import Glide from '@glidejs/glide';

const carousel = () => {
  const carouselElem = document.getElementsByClassName(
    'featured-articles-mobile-container'
  );

  if (carouselElem.length === 0) {
    return null;
  }

  Array.from(carouselElem).forEach(item => {
    new Glide(item, {
      type: 'carousel',
      autoplay: 4000,
      breakpoints: {
        500: {
          peek: {
            before: 0,
            after: 60
          }
        },
        750: {
          perView: 1,
          peek: {
            before: 0,
            after: 100
          }
        },
        990: {
          perView: 2,
          peek: {
            before: 0,
            after: 80
          }
        }
      }
    }).mount();
  });
};

const reviewCarousel = () => {
  const carouselElem = document.querySelectorAll(
    '.standout-review-reviews-container.glide'
  );

  if (carouselElem.length === 0) {
    return null;
  }

  Array.from(carouselElem).forEach(item => {
    new Glide(item, {
      type: 'carousel',
      autoplay: 4000,
      perView: 1,
      peek: {
        before: 0,
        after: 0
      }
    }).mount();
  });
};

const contentOverlapCarousel = () => {
  const carouselElem = document.querySelectorAll(
    '.image-content-overlap-carousel.glide'
  );

  if (carouselElem.length === 0) {
    return null;
  }

  Array.from(carouselElem).forEach(item => {
    console.log(item);
    if (item.querySelectorAll('.glide__slide').length > 1) {
      new Glide(item, {
        type: 'carousel',
        perView: 1
      }).mount();
    }
  });
};

const featuredItemsCarousel = () => {
  /*
  @devs - nb, this section is currently limited to only allow one per page. 
  the querySelector below will only rerturn the first element.
  Could be refactored to allow mutiple per page, but some rework would be needed 
  for the customisations.
  */
  const carouselElem = document.querySelector('.featured-items-carousel');

  if (
    !carouselElem ||
    carouselElem.querySelectorAll('.glide__slide').length === 0
  ) {
    return null;
  }

  const fic = new Glide(carouselElem, {
    type: 'carousel',
    breakpoints: {
      800: {
        perView: 1
      },
      1300: {
        perView: 2
      },
      9999: {
        focusAt: 'center',
        perView: 3
      }
    }
  }).mount();

  // Customisation of this glidejs instance
  // Enables the user to move the slider left and right by clicking on the cards
  // that are to the left and right of the active card.

  let current = fic.index;

  fic.on('move', () => {
    current = fic.index;
  });

  carouselElem.querySelectorAll('.glide__slide').forEach(slide => {
    slide.addEventListener('click', e => {
      const clickedId = parseInt(e.target.closest('li').dataset.index);

      const first = 0;
      const last =
        carouselElem.querySelectorAll('.glide__slide:not(.glide__slide--clone')
          .length - 1;
      const difference = Math.abs(clickedId - current);

      if (difference === 0) {
        return;
      } else if (difference === 1) {
        if (clickedId > current) {
          fic.go('>');
        } else if (clickedId < current) {
          fic.go('<');
        }
      } else {
        // if diff > 1 then we're at the first/last slide, and want to continue on to the next slide
        if (clickedId === first) {
          fic.go('>');
        } else if (clickedId === last) {
          fic.go('<');
        }
      }
    });
  });
};

const quotationsCarousel = () => {
  const carouselElem = document.querySelectorAll('.quotations-carousel');

  if (carouselElem.length === 0) {
    return null;
  }

  Array.from(carouselElem).forEach(item => {
    console.log(item);
    if (item.querySelectorAll('.glide__slide').length > 1) {
      new Glide(item, {
        type: 'carousel',
        perView: 2,
        gap: 25,
        breakpoints: {
          1200: {
            perView: 1
          }
        }
      }).mount();
    }
  });
};

const featuredProductsCarousel = () => {
  const carouselElem = document.querySelectorAll('.featured-products .glide');

  if (carouselElem.length === 0) {
    return null;
  }

  Array.from(carouselElem).forEach(elementInstance => {
    const carouselInstance = new Glide(elementInstance, {
      type: 'carousel',
      autoplay: false,
      perView: 1
    });
    carouselInstance.mount();

    // use intersection observer to play/pause carousel when inview
    //  https://developers.google.com/web/updates/2016/04/intersectionobserver
    const options = {
      threshold: 0.25
    };

    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        carouselInstance.play(2500);
      } else {
        carouselInstance.pause();
      }
    }, options);

    io.observe(elementInstance);
  });
};

export {
  carousel,
  reviewCarousel,
  contentOverlapCarousel,
  featuredItemsCarousel,
  quotationsCarousel,
  featuredProductsCarousel
};
